import { useLocalisation } from '@3plearning/lingui-cdn';
import React, { useState } from 'react';
import { Button } from '@3plearning/react-components';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { resetEntitiesAssignments } from '@containers/entities/entities-reducer';

import css from '../footer-popup/footer-popup.scss';
import UnassignButtonWrapper from './styled';

import { activateModal, dismissModal } from '../../../containers/modal-manager/modal-manager-actions';

import {
  groupAssignAndUnAssignAssignmentsSelector,
  selectAllAssignments,
  selectHasAssignments,
  selectIsAssigningOrUnAssigning
} from '../selectors';

import getTranslations from '../translations';

import { UNASSIGN_WARNING_MODAL_ID } from '../helpers';
import { UnAssignIcon, UnassignAll } from '../../../helpers/icon-dictionary';
import useManageAssignments from '../../../helpers/hooks/use-manage-assignments';
import OutsideClickHandler from '../../../helpers/hoc/close/outside-click-handler';

import FooterPopup from '../footer-popup';
import UnassignWarningModal from './unassign-warning-modal';

const unassignPopupOpenDefaultState = false;
const unassignButtonId = 'unassignButton';

const UnassignButton = () => {
  const dispatch = useDispatch();

  const { i18n } = useLocalisation();
  const {
    UNASSIGN_BUTTON_TEXT,
    UNASSIGN_TEXT,
    UNASSIGN_POPUP_TEXT,
    UNASSIGN_ALL_TEXT,
    UNASSIGN_ALL_POPUP_TEXT,
    UNASSIGN_ALL_CONFIRMATION_TEXT
  } = getTranslations({ i18n });

  const [unassignPopupOpen, setUnassignPopupOpen] = useState(unassignPopupOpenDefaultState);

  const allAssignments = useSelector(selectAllAssignments);
  const hasAssignments = useSelector(selectHasAssignments);
  const isAssigningOrUnAssigning = useSelector(selectIsAssigningOrUnAssigning);
  const { assignmentsToUnAssign } = useSelector(groupAssignAndUnAssignAssignmentsSelector);
  const previewModal = useSelector(state => state.modalContainerReducer, shallowEqual);

  const { unassignAssignments } = useManageAssignments();

  const onSubmitUnassignAll = async () => {
    await unassignAssignments(allAssignments, UNASSIGN_ALL_CONFIRMATION_TEXT);
    dispatch(dismissModal());
    dispatch(resetEntitiesAssignments());
    setUnassignPopupOpen(false);
  };
  const onUnassignClickHandler = () => setUnassignPopupOpen(prevState => !prevState);
  const onUnassignAllClickHandler = () => {
    setUnassignPopupOpen(false);
    dispatch(
      activateModal({
        content: <UnassignWarningModal callback={onSubmitUnassignAll} />,
        id: UNASSIGN_WARNING_MODAL_ID,
        buttons: [],
        className: css['modal-override']
      })
    );
  };
  const onOutsideClickHandlerCallback = () => {
    const isDisplayingModal = previewModal.length > 0 && previewModal[0].id === UNASSIGN_WARNING_MODAL_ID;

    if (!isDisplayingModal) setUnassignPopupOpen(unassignPopupOpenDefaultState);
  };

  const unassignAssignmentCount = assignmentsToUnAssign.length;

  const options = [
    {
      icon: UnAssignIcon,
      title: UNASSIGN_TEXT,
      description: UNASSIGN_POPUP_TEXT,
      onClickHandler: () => unassignAssignments(assignmentsToUnAssign),
      disabled: unassignAssignmentCount === 0 || isAssigningOrUnAssigning
    },
    {
      icon: UnassignAll,
      title: UNASSIGN_ALL_TEXT,
      description: UNASSIGN_ALL_POPUP_TEXT,
      onClickHandler: () => onUnassignAllClickHandler(),
      disabled: !hasAssignments
    }
  ];

  return (
    <>
      <OutsideClickHandler callback={() => onOutsideClickHandlerCallback()} forButton={unassignButtonId}>
        <UnassignButtonWrapper>
          <Button
            className="button"
            primary
            text={UNASSIGN_BUTTON_TEXT(unassignAssignmentCount)}
            type={Button.LOZENGE}
            onClick={() => onUnassignClickHandler()}
            alignIcon="LEFT"
            icon={UnAssignIcon}
          />
          <FooterPopup isOpen={unassignPopupOpen} options={options} />
        </UnassignButtonWrapper>
      </OutsideClickHandler>
    </>
  );
};

export default UnassignButton;



// WEBPACK FOOTER //
// ./components/footer/unassign-button/index.js